import { S3Client } from "@aws-sdk/client-s3";

interface Credentials {
  accessKey: string;
  secretKey: string;
  sessionToken: string;
}

export async function getS3ClientWithCredentials(credentials: Credentials): Promise<S3Client> {
  return new S3Client({
    region: "us-east-1",
    endpoint: process.env.REACT_APP_S3_BASE_URL, // MinIO endpoint
    forcePathStyle: true,
    requestChecksumCalculation: "WHEN_REQUIRED",
    credentials: {
      accessKeyId: credentials.accessKey,
      secretAccessKey: credentials.secretKey,
      sessionToken: credentials.sessionToken,
    },
  });
}
